import MainAddress from "../";
import { GetSerialProgram } from "../../util/sessionManager";
import { GetWithExpiry } from "../../util/sessionManager";
import { globalize } from "../../util/Handy/Inputs/numberOnly";
import axios from 'axios';

export async function RegNewRequest(data){
    try{
        const response = await axios.post(
            MainAddress+"visitor/reg_newInvoice.php",
            {
                ...data,
                serial_program:GetSerialProgram(),
                visitorLine:JSON.parse(localStorage.getItem("activeLine")).code,
                code_visitor:GetWithExpiry("user").code
            }
          )
        if(response.data.success){
            return response.data;
        }else{
            return {
                success:false,
                message:response
            };
        }
    }catch(error){
        return {
            success:false,
            message:error
        };
    }

}



export async function GetGifts(data){
    try{
        const response = await axios.post(
            MainAddress+"visitor/read_gifts.php",
            {
                ...data,
                serial_program:GetSerialProgram(),
                date:globalize(
                    new Date().toLocaleDateString("fa-IR")
                      .split("/")
                      .map((i) => {
                        return i.toString().length > 1 ? i : "0" + i;
                      })
                      .join("/")
                    )
            }
          )
          
          console.log("gifts: ",response);
        if(response.data.success ){  
            return {success:response.data.success,
                data:response.data
            };
        }else{
            return {
                success:false,
                message:response
            };
        }
    }catch(error){
        return {
            success:false,
            message:error
        };
    }

}